import React, { useState, useEffect, useRef } from "react";
import { Card, Image, Button, Dropdown, Nav, Spinner } from "react-bootstrap";
import moment from "moment";
import { changeLanguage, setCurrentEvent } from "../../store/actions/actions";
import { connect } from "react-redux";
import { languageText } from "./language.json";
import { ticketTiers } from "./ticketTiers.json";
import { useHistory, useLocation } from "react-router-dom";
import { useParams } from "react-router";
import firebase from "firebase";
import { useCollection, useDocument } from "react-firebase-hooks/firestore";
import {
  API_BASE_URL,
  INVITE_PROCESS,
  USER_EXISTS,
  EVENT_USER_DETAILS,
  EVENT_DETAILS,
} from "../../config";
import * as EventStyle from "./event.module.css";
import ReadMore from "../ReadMore";
import { loadState, saveState } from "../../services";
import {
  Formik,
  Field,
  Form,
  ErrorMessage,
  FieldArray,
  yupToFormErrors,
  getIn,
} from "formik";
import * as Yup from "yup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faDownload,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import { postData, sendEmail } from "../../utils/index";
import * as DeviceDetect from "react-device-detect";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { PROD_HOSTED_BASE_URL } from "../../config";

toast.configure();

function EventAuthentication({
  currentLanguage,
  changeLanguage,
  darkTheme,
  currentEvent,
  setCurrentEvent,
}) {
  const { pathname } = useLocation();
  const history = useHistory();
  const { id, email_address } = useParams();
  const ticket_available = false;
  console.log({ email_address });

  const [loggingSpinner, setLoggingSpinner] = useState(false);
  const [signing, setSigning] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [selectedTicketType, setSelectedTicketType] = useState(0);
  const [ticketSelected, setTicketSelected] = useState(false);
  const [route, setRoute] = useState("");

  const [userDetails, setUserDetails] = useState({
    first_name: "",
    last_name: "",
    phone_number: "",
    email_address: "",
    password_value: "",
  });
  const current_user = firebase.auth().currentUser;
  const [currentUserIsPart, setCurrentUserIsPart] = useState(false);

  // const [eventSnapshot, loadingEvent, errorEvent] = useCollection(
  //   // data not fetch
  //   firebase
  //     .firestore()
  //     .collection("events")
  //     .where("isDemo", "==", true)
  //     .where("slug", "==", `${id}`)
  // );

  // useEffect(() => {
  //   if (eventSnapshot) {
  //     setCurrentEvent({
  //       ...eventSnapshot?.docs[0]?.data(),
  //       id: eventSnapshot?.docs[0]?.id,
  //     });
  //   }
  //   console.log({ currentEvent });
  // }, [eventSnapshot, loadingEvent]);

  const pageRef = useRef(null);
  useEffect(() => {
    pageRef && pageRef.current.scrollIntoView();

    if (ticket_available) {
      // if tickets are available only
      loadState("ticket_type") &&
        setSelectedTicketType(parseInt(loadState("ticket_type")));
      loadState("ticket_selected") &&
        setTicketSelected(loadState("ticket_selected"));
    }
  }, []);

  useEffect(() => {
    if (pathname.split("/")[3] && pathname.split("/")[3] === "register") {
      setRoute("register");
    }
    if (pathname.split("/")[3] && pathname.split("/")[3] === "login") {
      setRoute("login");
    }
  }, [pathname]);

  const getEventDetails = async () => {
    try {
      const response = await postData(`${API_BASE_URL}${EVENT_DETAILS}`, {
        event_slug: `${id}`,
      });

      if (response.status == 200) {
        return response.data;
      }
    } catch (error) {
      console.error("Error fetching event details:", error);
      throw error;
    }
  };

  useEffect(() => {
    if (currentEvent == null && id != null) {
      getEventDetails()
        .then((data) => setCurrentEvent({ ...data, id: data?.event_id }))
        .catch((err) => console.log(err));
    }
  }, [id, currentEvent]);

  useEffect(async () => {
    if (current_user && currentEvent?.id != null) {
      const response_user_details = await postData(
        `${API_BASE_URL}${EVENT_USER_DETAILS}`,
        {
          event_id: currentEvent?.id,
          user_id: current_user?.uid,
        }
      );

      if (response_user_details.status == 200) {
        const { data } = response_user_details;

        setCurrentUserIsPart(true);

        if (data.custom_form_required && !data.custom_form_filled) {
          history.push("./fill-details");
        }
      }
    }
  }, [current_user, currentEvent]);

  const redirectToDashboard = () => {
    if (pathname.split("/").length === 4) history.push("./dashboard");
    else history.push("../dashboard");
  };

  const redirectToRegister = () => {
    if (pathname.split("/").length === 4) history.push("./register");
    else history.push("../register");
  };

  const redirectToLogin = () => {
    if (pathname.split("/").length === 4) history.push("./login");
    else history.push("../login");
  };

  const processRoomInvite = (inviteProcessData) => {
    axios
      .post(`https://api.igesia.com${INVITE_PROCESS}`, inviteProcessData)
      .then((response) => {
        console.log("Invite processing: ", response?.response?.data?.message);
      })
      .catch((error) => {
        console.error(
          "Error processing invite: ",
          error?.response?.data?.message
        );
      });
  };

  const _handleUpdateProfile = (
    firstName,
    lastName,
    resetForm = null,
    values,
    session_id = null,
    inviteeUID = null,
    inviteeData = {}
  ) => {
    const authUser = firebase.auth().currentUser;
    authUser
      .updateProfile({
        displayName: `${firstName} ${lastName}`,
        photoURL:
          "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/avatars%2Fusers%2Fsolo-icon.svg?alt=media&token=0279ff83-ebf4-420f-bc28-e5f6b10a7822",
      })
      .then(() => {
        _handleSaveUser(
          authUser,
          firstName,
          lastName,
          values,
          session_id,
          inviteeUID,
          inviteeData,
          resetForm
        );
      })
      .catch((error) => console.error(error));
  };

  const _handleSaveUser = (
    authUser,
    firstName,
    lastName,
    values,
    session_id,
    inviteeUID,
    inviteeData,
    resetForm
  ) => {
    return firebase
      .firestore()
      .collection("users")
      .doc(`${authUser.uid}`)
      .set({
        displayName: authUser.displayName,
        avatar: authUser.photoURL,
        firstName: firstName,
        lastName: lastName,
        // middleName: middleName,
        email: authUser.email,
        emailVerified: authUser.emailVerified,
        phoneNumber: values?.phone,
        providerData: JSON.parse(JSON.stringify(authUser.providerData)),
        uid: authUser.uid,
        isAnonymous: authUser.isAnonymous,
        deviceInfo: DeviceDetect.deviceDetect(),
        deviceType: DeviceDetect.deviceType,
        device: DeviceDetect.isMobile
          ? DeviceDetect.isMobileOnly
            ? "Mobile"
            : "Tablet"
          : "Desktop",
        electron: DeviceDetect.isElectron ? true : false,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      })
      .then(function (response) {
        firebase
          .firestore()
          .collection(`/events/${currentEvent?.id}/users/`)
          .doc(authUser.uid)
          .set({
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            phone: values.phone,
            timestamp: new Date(),
            uid: authUser.uid,
            certificate: { willReceive: false },
            alreadyExists: false,
            custom_form_filled: false,
            user_role: inviteeData?.user_role,
            category: inviteeData?.category,
            is_speaker: inviteeData.is_speaker ?? false,
          })
          .then(() => {
            firebase
              .firestore()
              .collection(`/events/${currentEvent?.id}/invitees/`)
              .doc(inviteeUID)
              .update({
                uid: authUser.uid,
                claimed_at: Date.now(),
              })
              .then(() => {
                toast.success("Registered successfully", {
                  position: toast.POSITION.TOP_CENTER,
                  hideProgressBar: true,
                  autoClose: 3000,
                });
              });

            resetForm();

            redirectToDashboard();
          });
        console.log(authUser.uid);
      })
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });
  };

  const continueWithNewEmail = async (
    resetForm,
    email,
    pass,
    firstName,
    lastName,
    values
  ) => {
    try {
      const response = await postData(`${API_BASE_URL}${USER_EXISTS}`, {
        email: email,
      });

      if (response?.data?.exist) {
        toast.warning(
          "You are already registered with Igesia. Please login to register for the event",
          {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            autoClose: 3000,
          }
        );
        redirectToLogin();
        return;
      }

      const createdUser = await firebase
        .auth()
        .createUserWithEmailAndPassword(email, pass);
      createdUser.user.sendEmailVerification();

      if (createdUser.operationType === "signIn") {
        console.log("START: Updating profile");
        await createdUser.user.updateProfile({
          displayName: `${firstName} ${lastName}`,
          photoURL:
            "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/avatars%2Fusers%2Fsolo-icon.svg?alt=media&token=0279ff83-ebf4-420f-bc28-e5f6b10a7822",
        });
        console.log("END: Updating profile");

        console.log("START: Adding user");
        await firebase
          .firestore()
          .collection("users")
          .doc(`${createdUser.user.uid}`)
          .set({
            displayName: `${firstName} ${lastName}`,
            avatar:
              "https://firebasestorage.googleapis.com/v0/b/igesia-web-a5934.appspot.com/o/avatars%2Fusers%2Fsolo-icon.svg?alt=media&token=0279ff83-ebf4-420f-bc28-e5f6b10a7822",
            firstName: firstName,
            lastName: lastName,
            email: email,
            emailVerified: false,
            phoneNumber: values?.phone ?? "",
            providerData: JSON.parse(
              JSON.stringify(createdUser.user.providerData)
            ),
            uid: createdUser.user.uid,
            isAnonymous: false,
            deviceInfo: DeviceDetect.deviceDetect(),
            deviceType: DeviceDetect.deviceType,
            device: DeviceDetect.isMobile
              ? DeviceDetect.isMobileOnly
                ? "Mobile"
                : "Tablet"
              : "Desktop",
            electron: DeviceDetect.isElectron ? true : false,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          });
        console.log("END: Adding user");

        console.log("START: Enrolling user");
        const response_enrollment = await postData(
          `${API_BASE_URL}/events/public/enroll-event`,
          {
            event_id: currentEvent?.id,
            user_id: createdUser.user.uid,
            first_name: firstName,
            last_name: lastName,
            phone_number: values.phone,
            email: values.email,
          }
        );

        if (response_enrollment.status === 200) {
          toast.success("Registered successfully", {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            autoClose: 3000,
          });

          redirectToDashboard();
        } else {
          toast.error(response_enrollment.message, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            autoClose: 3000,
          });
        }
        console.log("END: Enrolling user");
      }
    } catch (error) {
      console.log(`[Error] Registering into event: `, error);
    }
  };

  const continueWithEmail = async (
    resetForm,
    email,
    pass,
    firstName,
    lastName,
    values
  ) => {
    if (currentEvent?.invite_only) {
      try {
        setSigning(true);
        const response = await postData(`${API_BASE_URL}${USER_EXISTS}`, {
          email: email,
        });
        const { data, message, status } = response;
        if (status === 200) {
          if (data.exist) {
            let valuesWithoutEmailAndPass = values;
            valuesWithoutEmailAndPass.alreadyExists = true;
            // delete valuesWithoutEmailAndPass.email;
            delete valuesWithoutEmailAndPass.pass;
            delete valuesWithoutEmailAndPass.confirmpass;
            window.localStorage.setItem(
              "values",
              JSON.stringify(valuesWithoutEmailAndPass)
            );
            toast.warning(
              "You are already registered with Igesia. Please login to register for the event",
              {
                position: toast.POSITION.TOP_CENTER,
                hideProgressBar: true,
                autoClose: 3000,
              }
            );
            history.push("./login");
          } else {
            const emailAllowed = (
              await firebase
                .firestore()
                .collection(`/events/${currentEvent?.id}/invitees`)
                .where("email_address", "==", email.toLowerCase())
                .get()
            ).docs.length;
            if (emailAllowed) {
              const createdUser = await firebase
                .auth()
                .createUserWithEmailAndPassword(email, pass);
              createdUser.user.sendEmailVerification();

              await postData("https://dev.igesia.com/data/push", {
                point_type: "event.new_registration_invite_only",
                data_properties: {
                  event_id: currentEvent?.id,
                  email: email,
                  location: loadState("accessCountryCode") ?? "IN",
                },
              });

              const inviteeRef = await firebase
                .firestore()
                .collection(`/events/${currentEvent?.id}/invitees`)
                .where("email_address", "==", email.toLowerCase())
                .get();

              const inviteeUID = inviteeRef.docs[0].id;
              const inviteeData = inviteeRef.docs[0].data();

              if (createdUser.operationType === "signIn") {
                _handleUpdateProfile(
                  firstName,
                  lastName,
                  resetForm,
                  values,
                  null,
                  inviteeUID,
                  inviteeData
                );

                // alert(`Room invite code: ${currentEvent?.room_invite_code} & ${createdUser?.uid}`)
                if (currentEvent?.room_invite_code) {
                  const inviteProcessData = {
                    invite_code: currentEvent?.room_invite_code,
                    user_id: createdUser?.uid,
                  };

                  processRoomInvite(inviteProcessData);
                }
              }
            } else {
              toast.error("You are not invited", {
                position: toast.POSITION.TOP_CENTER,
                hideProgressBar: true,
                autoClose: 3000,
              });
            }
          }
        }
      } catch (e) {
        console.error(e, "error in signing user");
      } finally {
        setSigning(false);
      }
    } else {
      try {
        setSigning(true);
        postData(`${API_BASE_URL}${USER_EXISTS}`, { ["email"]: email }).then(
          async (response) => {
            const { data, message, status } = response;
            if (status === 200) {
              if (data.exist) {
                let valuesWithoutEmailAndPass = values;
                valuesWithoutEmailAndPass.alreadyExists = true;
                delete valuesWithoutEmailAndPass.pass;
                delete valuesWithoutEmailAndPass.confirmpass;
                window.localStorage.setItem(
                  "values",
                  JSON.stringify(valuesWithoutEmailAndPass)
                );
                // console.log("user found", response);
                toast.info(
                  "You are already registered with Igesia. Please login to register for the event",
                  {
                    position: toast.POSITION.TOP_CENTER,
                    hideProgressBar: true,
                    autoClose: 3000,
                  }
                );
                history.push("login");
              } else {
                firebase
                  .auth()
                  .createUserWithEmailAndPassword(email, pass)
                  .then(async (createdUser) => {
                    createdUser.user.sendEmailVerification();

                    // const response = await fetch('https://05e4wl8tgc.execute-api.us-east-1.amazonaws.com/production/hello', {
                    //   method: "GET",
                    //   mode: "cors",
                    //   cache: "no-cache",
                    //   redirect: "follow",
                    //   referrerPolicy: "no-referrer"
                    // });

                    await postData("https://dev.igesia.com/data/push", {
                      point_type: "event.new_registration",
                      data_properties: {
                        event_id: currentEvent?.id,
                        email: email,
                        location: "IN",
                      },
                    });

                    console.log("Data exist please sign in only");
                    if (createdUser.operationType === "signIn") {
                      _handleUpdateProfile(
                        firstName,
                        lastName,
                        resetForm,
                        values
                      );
                    }
                    // alert(`Room invite code: ${currentEvent?.room_invite_code} & ${createdUser?.uid}`)
                    if (currentEvent?.room_invite_code) {
                      const inviteProcessData = {
                        invite_code: currentEvent?.room_invite_code,
                        user_id: createdUser?.uid,
                      };

                      processRoomInvite(inviteProcessData);
                    }
                  })
                  .catch((err) => {
                    console.error(err.message);
                    console.log("Data exist please sign in only2");
                  });
              }
            }
          }
        );
      } catch (e) {
        console.error(e, "error in signing user");
        setTimeout(() => setSigning(false), 1000);
      } finally {
        setTimeout(() => setSigning(false), 1000);
      }
    }
  };

  const handleLogin = async (resetForm, email, pass) => {
    if (currentEvent?.invite_only) {
      try {
        setLoggingSpinner(true);
        const response = await postData(`${API_BASE_URL}${USER_EXISTS}`, {
          email: email,
        });
        const { data, message, status } = response;
        if (status === 200) {
          const emailAllowed = (
            await firebase
              .firestore()
              .collection(`/events/${currentEvent?.id}/invitees`)
              .where("email_address", "==", email.toLowerCase())
              .get()
          ).docs.length;
          if (data.exist && emailAllowed) {
            const querySnapshot = await firebase
              .firestore()
              .collection(`/events/${currentEvent?.id}/invitees`)
              .where("email_address", "==", email)
              .get();

            const inviteeUID = querySnapshot.docs[0].id;
            const inviteeData = querySnapshot.docs[0].data();

            const user = await firebase
              .auth()
              .signInWithEmailAndPassword(email, pass);
            const userDetailsUsersCollection = await firebase
              .firestore()
              .collection("users")
              .doc(user.user.uid)
              .get();
            const userData = userDetailsUsersCollection.data();
            const userDetails = await firebase
              .firestore()
              .collection(`/events/${currentEvent?.id}/users`)
              .doc(user.user.uid)
              .get();
            if (!userDetails.exists) {
              await firebase
                .firestore()
                .collection(`/events/${currentEvent?.id}/users`)
                .doc(user.user.uid)
                .set({
                  email: userData.email,
                  firstName: userData.firstName,
                  lastName: userData.lastName,
                  phone: userData.phone ? userData.phone : null,
                  uid: userData.uid,
                  timestamp: new Date(),
                  user_role: inviteeData.user_role,
                  is_speaker: inviteeData.is_speaker ?? false,
                  category: inviteeData.category,
                });
              await firebase
                .firestore()
                .collection(`/events/${currentEvent?.id}/invitees`)
                .doc(inviteeUID)
                .update({
                  uid: userData.uid,
                  claimed_at: Date.now(),
                });

              redirectToDashboard();

              // alert(`Room invite code: ${currentEvent?.room_invite_code} & ${userData?.uid}`)
              if (currentEvent?.room_invite_code) {
                const inviteProcessData = {
                  invite_code: currentEvent?.room_invite_code,
                  user_id: userData?.uid,
                };

                processRoomInvite(inviteProcessData);
              }

              toast.success("Registered Successfully", {
                position: toast.POSITION.TOP_CENTER,
                hideProgressBar: true,
                autoClose: 3000,
              });

              const firstName = userData.firstName;
              // sendEmail({
              //   to: userData.email,
              //   subject:
              //     "Registration successful  - Blue Ocean Awards - 7th Edition",
              //   content: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head> <!--[if gte mso 9]> <xml> <o:OfficeDocumentSettings> <o:AllowPNG/> <o:PixelsPerInch>96</o:PixelsPerInch> </o:OfficeDocumentSettings> </xml> <![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><meta name="x-apple-disable-message-reformatting"> <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible" content="IE=edge"> <!--<![endif]--><title></title><style type="text/css">a{color:#161a39;text-decoration:underline}@media only screen and (min-width: 620px){.u-row{width:600px !important}.u-row .u-col{vertical-align:top}.u-row .u-col-100{width:600px !important}}@media (max-width: 620px){.u-row-container{max-width:100% !important;padding-left:0px !important;padding-right:0px !important}.u-row .u-col{min-width:320px !important;max-width:100% !important;display:block !important}.u-row{width:calc(100% - 40px) !important}.u-col{width:100% !important}.u-col>div{margin:0 auto}}body{margin:0;padding:0}table,tr,td{vertical-align:top;border-collapse:collapse}p{margin:0}.ie-container table, .mso-container table{table-layout:fixed}*{line-height:inherit}a[x-apple-data-detectors='true']{color:inherit !important;text-decoration:none !important}</style><!--[if !mso]><!--><link href="https://fonts.googleapis.com/css?family=Lato:400,700&display=swap" rel="stylesheet" type="text/css"> <!--<![endif]--></head><body class="clean-body" style="margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #f9f9f9"> <!--[if IE]><div class="ie-container"><![endif]--> <!--[if mso]><div class="mso-container"><![endif]--><table style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #f9f9f9;width:100%" cellpadding="0" cellspacing="0"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #f9f9f9;"><![endif]--><div class="u-row-container" style="padding: 0px;background-color: #f9f9f9"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: #f9f9f9;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:15px;font-family:'Lato',sans-serif;" align="left"><table height="0px" align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 1px solid #f9f9f9;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"> <span>&#160;</span></td></tr></tbody></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:25px 0px;font-family:'Lato',sans-serif;" align="left"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 20px; padding-left: 30px;" align="left"><img align="left" border="0" src="https://igesia-assets.s3.ap-south-1.amazonaws.com/all-in-one/BOA.png" alt="Image" title="Image" style="outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both; display: inline-block !important;border: none;height: auto;float: none;width: 53%;max-width: 307.4px; border-radius: 4px;" width="307.4" /></td></tr></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:10px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;"><span style="font-size: 18px; line-height: 25.2px; color: #34495e; font-family: helvetica, sans-serif;">Hi ${firstName}, </span></p><p style="font-size: 14px; line-height: 140%;">&nbsp;</p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;">You're now registered for Blue Ocean Awards - 7th Edition. </span></p><p style="font-size: 14px; line-height: 140%;"> <br /><span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;">Look forward <span style="line-height: 25.2px; font-size: 18px;">to</span> seeing you on May 11.&nbsp;</span></p></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px;font-family:'Lato',sans-serif;" align="left"><div align="left"> <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:'Lato',sans-serif;"><tr><td style="font-family:'Lato',sans-serif;" align="left"><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="" style="height:51px; v-text-anchor:middle; width:253px;" arcsize="2%" stroke="f" fillcolor="#3598db"><w:anchorlock/><center style="color:#FFFFFF;font-family:'Lato',sans-serif;"><![endif]--> <a href="https://events.igesia.co/course/artificialintelligence/console/" target="_blank" style="box-sizing: border-box;display: inline-block;font-family:'Lato',sans-serif;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #FFFFFF; background-color: #3598db; border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px; width:auto; max-width:100%; overflow-wrap: break-word; word-break: break-word; word-wrap:break-word; mso-border-alt: none;"> <span style="display:block;padding:15px 40px;line-height:120%;"><strong><span style="font-size: 18px; line-height: 21.599999999999998px;">Visit Event Reception</span></strong></span> </a> <!--[if mso]></center></v:roundrect></td></tr></table><![endif]--></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:40px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;"><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="line-height: 19.599999999999998px; font-size: 14px;">Event powered by <a href="http://events.igesia.co/" target="_blank" rel="noopener">igesia</a></span></em></span></p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 14px; line-height: 19.599999999999998px;">&copy; [igesia] 2021. All rights reserved.</span><br /><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="font-size: 16px; line-height: 22.4px;">&nbsp;</span></em></span></p></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px 30px 20px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><!--[if (mso)|(IE)]></td></tr></table><![endif]--></td></tr></tbody></table> <!--[if mso]></div><![endif]--> <!--[if IE]></div><![endif]--></body></html>`,
              //   from: '"igesia" <noreply@igesia.co>',
              // });
            }
            redirectToDashboard();
          } else {
            toast.error(
              "Looks like you do not have invitation for this event.",
              {
                position: toast.POSITION.TOP_CENTER,
                hideProgressBar: true,
                autoClose: 3000,
              }
            );
          }
        }
      } catch (e) {
        console.error(e, "error in signing in");
        toast.error(e.message, {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          autoClose: 3000,
        });
      } finally {
        setLoggingSpinner(false);
      }
    } else {
      try {
        setLoggingSpinner(true);
        postData(`${API_BASE_URL}${USER_EXISTS}`, { ["email"]: email }).then(
          async (response) => {
            firebase
              .auth()
              .signInWithEmailAndPassword(email, pass)
              .then((signedInUser) => {
                toast.success("Logged in successfully", {
                  position: toast.POSITION.TOP_CENTER,
                  hideProgressBar: true,
                  autoClose: 3000,
                });

                firebase.auth().onAuthStateChanged(async (signed_user) => {
                  if (signed_user) {
                    const querySnapshot = await firebase
                      .firestore()
                      .collection(`/events/${currentEvent?.id}/users`)
                      .where("email", "==", email)
                      .get();

                    if (querySnapshot?.empty) {
                      toast.info(
                        `Hello ${email}, looks like you are not registered for this event`,
                        {
                          position: toast.POSITION.TOP_CENTER,
                          hideProgressBar: true,
                          autoClose: 3000,
                        }
                      );
                      history.push("./complete-registration");
                    } else {
                      // alert(`Room invite code: ${currentEvent?.room_invite_code} & ${signed_user?.uid}`)
                      if (currentEvent?.room_invite_code) {
                        const inviteProcessData = {
                          invite_code: currentEvent?.room_invite_code,
                          user_id: signed_user?.uid,
                        };

                        processRoomInvite(inviteProcessData);
                      }

                      querySnapshot.forEach((doc) => {
                        if (doc.data()) {
                          redirectToDashboard();
                        }
                      });
                    }
                  }
                });
              })
              .catch((error) => {
                toast.error(error.message, {
                  position: toast.POSITION.TOP_CENTER,
                  hideProgressBar: true,
                  autoClose: 3000,
                });
              });
          }
        );
      } catch (e) {
        toast.error("User not Found", {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          autoClose: 3000,
        });
        setTimeout(() => setLoggingSpinner(false), 1000);
      } finally {
        setTimeout(() => setLoggingSpinner(false), 1000);
      }
    }
  };

  const handleNewLogin = async (resetForm, email, pass) => {
    try {
      setLoggingSpinner(true);

      const response = await postData(`${API_BASE_URL}${USER_EXISTS}`, {
        email: email,
      });

      if (!response?.data?.exist) {
        toast.error("Email address not registered", {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: false,
          autoClose: 3000,
        });
        setLoggingSpinner(false);
        return;
      }

      const user = await firebase
        .auth()
        .signInWithEmailAndPassword(email, pass);

      window.location.reload();

      const response_user_details = await postData(
        `${API_BASE_URL}${EVENT_USER_DETAILS}`,
        {
          event_id: currentEvent?.id,
          user_id: user.user.uid,
        }
      );

      if (response_user_details.status === 200) {
        toast.success("Registered Successfully", {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          autoClose: 3000,
        });
        redirectToDashboard();
      } else {
        toast.success("Email address not registered", {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          autoClose: 3000,
        });
        redirectToRegister();
      }

      setLoggingSpinner(false);
    } catch (error) {
      console.log(`[Error] Logging into event: `, error);
      setLoggingSpinner(false);
    }
  };

  const handleTicketType = () => {
    saveState("ticket_type", selectedTicketType);
    saveState("ticket_selected", true);
    setTicketSelected(true);
  };

  const phoneRegExp =
    /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;
  const RegisterVaildationSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(1, "Please add valid name")
      .required("First name is required"),
    lastName: Yup.string()
      .min(1, "Please add valid name")
      .required("Last name is required"),
    phone: Yup.string().matches(phoneRegExp, "Phone number is not valid"),
    email: Yup.string().required("Required"),
    password: Yup.string()
      .min(6, "Password must be atleast 6 characters long")
      .required("Required*"),
  });

  const LoginVaildationSchema = Yup.object().shape({
    email: Yup.string().required("Required"),
    password: Yup.string()
      .min(6, "Password must be atleast 6 characters long")
      .required("Required"),
  });

  const handleRouteChange = (e) => {
    if (pathname.split("/").length == 5) {
      history.push(`../${e}`);
    }

    if (pathname.split("/").length == 4) {
      history.push(`${e}`);
    }
  };

  const convertSecondstoMilliSeconds = (seconds) => {
    return Math.floor(seconds * 1000);
  };

  return (
    <div
      className="container-fluid px-0 full-screen"
      data-theme={darkTheme ? "dark" : "light"}
      ref={pageRef}
    >
      {/* Top navigation start */}
      <div className="container pt-3 pt-md-4 d-flex align-items-center justify-content-between">
        <div
        //  onClick={() => history.push(`/`)}
        >
          <Image
            className={`rounded ${EventStyle.event_cover_logo}`}
            src={process.env.PUBLIC_URL + "/assets/Igesia-Logo.svg"}
          />
        </div>
        <Dropdown className="mr-3 small">
          <Dropdown.Toggle
            as="div"
            id="dropdown-basic"
            style={{ cursor: "pointer" }}
          >
            {currentLanguage === "EN" ? "EN" : "FR"}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              className="small"
              active={currentLanguage === "EN"}
              onClick={() => changeLanguage("EN")}
            >
              {languageText[`${currentLanguage}`].english}
            </Dropdown.Item>
            {/* <Dropdown.Item
              className="small"
              active={currentLanguage === "FR"}
              onClick={() => changeLanguage("FR")}
            >
              {languageText[`${currentLanguage}`].french}
            </Dropdown.Item> */}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      {/* Top navigation end */}

      {/* Event cover starts */}
      <div className="container pt-3 pt-md-4">
        <div className="row">
          <div className="col-md-8 col-12 mx-auto text-center">
            <h2 className="font-weight-bold">
              {currentEvent?.event_details?.EN?.event_name}
            </h2>
            <p className=" mb-1">
              {moment(
                convertSecondstoMilliSeconds(
                  currentEvent?.event_details?.start_date?._seconds
                )
              ).format("DD MMMM YYYY")}
            </p>
          </div>
        </div>
        <div className="row pb-5">
          <div className="col-md-8 col-12 mx-auto bg-transparent w-100">
            <Card
              className="rounded-lg shadow"
              style={{ position: "sticky", top: 60 }}
            >
              {!!current_user ? (
                currentUserIsPart ? (
                  <Card.Body className="p-3">
                    <p className="text-center h5 mb-3">
                      Already logged in as <b>{current_user?.displayName}</b>
                    </p>
                    <div className="d-flex flex-column align-items-center">
                      <img
                        width="100"
                        height="100"
                        className="img-fluid rounded-circle shadow-sm"
                        src={current_user?.photoURL}
                      />
                      <p className="align-items-center">
                        Not{" "}
                        <b>
                          {current_user?.displayName} ({current_user?.email})
                        </b>
                        ?{" "}
                        <a
                          className="btn btn-sm btn-primary"
                          onClick={async () => {
                            await firebase.auth().signOut();

                            toast.dark("Logged out", {
                              position: toast.POSITION.TOP_CENTER,
                              hideProgressBar: true,
                              autoClose: 3000,
                            });
                          }}
                        >
                          Logout
                        </a>
                      </p>
                      <div className="w-50">
                        <Button
                          className="text-uppercase w-100 rounded-sm"
                          onClick={redirectToDashboard}
                        >
                          <small>Visit Reception</small>
                        </Button>
                      </div>
                    </div>
                  </Card.Body>
                ) : (
                  <Card.Body className="p-3">
                    <p className="text-center h5 mb-3">
                      Already logged in as <b>{current_user?.displayName}</b>
                    </p>
                    <div className="d-flex flex-column align-items-center">
                      <img
                        width="100"
                        height="100"
                        className="img-fluid rounded-circle shadow-sm"
                        src={current_user?.photoURL}
                      />
                      <p className="align-items-center">
                        Not{" "}
                        <b>
                          {current_user?.displayName} ({current_user?.email})
                        </b>
                        ?{" "}
                        <a
                          className="btn btn-sm btn-primary"
                          onClick={async () => {
                            await firebase.auth().signOut();

                            toast.dark("Logged out", {
                              position: toast.POSITION.TOP_CENTER,
                              hideProgressBar: true,
                              autoClose: 3000,
                            });
                          }}
                        >
                          Logout
                        </a>
                      </p>
                      <div className="w-50">
                        <Button
                          className="text-uppercase w-100 rounded-sm"
                          onClick={() =>
                            history.push("./complete-registration")
                          }
                        >
                          <small>Register</small>
                        </Button>
                        <p className="text-center text-danger small mt-2 mb-1">
                          <b>Notice</b>: Looks like you are not registered for
                          this event
                        </p>
                      </div>
                    </div>
                  </Card.Body>
                )
              ) : route === "register" && ticket_available ? (
                !ticketSelected && (
                  <Card.Body className="p-3">
                    <h4>Register</h4>
                    <div>
                      {ticketTiers[`${currentLanguage}`].map((tier, id) => (
                        <div className="border rounded py-2 mb-2 form-check">
                          <div className="d-flex justify-content-between">
                            <div className="pl-2">
                              <input
                                className="form-check-input"
                                checked={selectedTicketType == tier.id}
                                disabled={!tier.enabled}
                                value={tier.id}
                                onChange={(e) => {
                                  setSelectedTicketType(e.target.value);
                                }}
                                type="radio"
                                name="flexRadioDefault"
                                id={`flexRadioDefault${id}`}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`flexRadioDefault${id}`}
                              >
                                <h5
                                  className="mb-0 text-s-8"
                                  style={{ whiteSpace: "pre-line" }}
                                >
                                  {tier.tierName}
                                </h5>
                                {tier.limitedTickets && (
                                  <p className="small mb-0 text-danger font-weight-bold">
                                    {languageText[`${currentLanguage}`].only}{" "}
                                    {tier.ticketsLeft}{" "}
                                    {languageText[`${currentLanguage}`].left}
                                  </p>
                                )}
                                <p className="small mb-0">
                                  <ReadMore
                                    full_text={tier.tierDescription}
                                    max_length={80}
                                  />
                                </p>
                                {tier.taxExclusive && (
                                  <p className="text-secondary mb-0 mt-1 small">
                                    *{tier.taxPercentage}%{" "}
                                    {
                                      languageText[`${currentLanguage}`]
                                        .taxExcluded
                                    }
                                  </p>
                                )}
                              </label>
                            </div>
                            <div className="text-right text-s-11 font-weight-bold pr-2">
                              {tier.priceLabel}
                              {tier.taxExclusive && "*"}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    <Button
                      className="w-100 rounded-lg"
                      onClick={handleTicketType}
                    >
                      <small className="font-weight-bold">Register</small>
                    </Button>
                    <small>Above mentioned fees is per participant</small>
                  </Card.Body>
                )
              ) : (
                <Card.Body
                  className={
                    darkTheme
                      ? "bg-dark border-secondary p-3 "
                      : "bg-white border-light p-3 "
                  }
                >
                  <p className="h5 text-center my-2">
                    {route === "register" ? "Register" : "Log in"} for an igesia
                    account
                    <br />
                    to join
                    {/* for
                        <br/>{programName} */}
                  </p>
                  <div className="mb-3">
                    <Nav
                      variant="pills"
                      onSelect={handleRouteChange}
                      activeKey={route}
                      className="w-100 border rounded-pill m-0"
                    >
                      <Nav.Item className="w-50">
                        <Nav.Link
                          className="py-1 text-center rounded-pill"
                          eventKey="register"
                        >
                          Register
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item className="w-50">
                        <Nav.Link
                          className="py-1 text-center rounded-pill"
                          eventKey="login"
                        >
                          Log in
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>

                    {route === "register" ? (
                      <div>
                        <Formik
                          validationSchema={RegisterVaildationSchema}
                          initialValues={{
                            firstName: "",
                            lastName: "",
                            email: email_address ?? "",
                            phone: "",
                            password: "",
                            timestamp: new Date(),
                            alreadyExists: false,
                          }}
                          onSubmit={(values, { resetForm }) => {
                            continueWithNewEmail(
                              resetForm,
                              values.email,
                              values.password,
                              values.firstName,
                              values.lastName,
                              values
                            );
                          }}
                        >
                          {({ errors, touched, isValidating, values }) => (
                            <Form>
                              <div className="">
                                {/* <div >
                                  <p className="text-dark mb-2">Register for the event. <br />Simply fill out this form to sign up</p>
                                   <small className="text-muted"><span className="font-weight-bold">Note: </span>All the fields in this form are mandatory.</small> 
                                </div> */}

                                <div className="form-label-group mt-3">
                                  <label htmlFor="firstName" className="mb-1">
                                    First name
                                  </label>
                                  <Field
                                    name="firstName"
                                    id="firstName"
                                    type="text"
                                    placeholder="First name"
                                    className="form-control"
                                  ></Field>

                                  {errors.firstName && touched.firstName ? (
                                    <div className="text-danger ml-2">
                                      {errors.firstName}
                                    </div>
                                  ) : null}
                                </div>
                                <div className="form-label-group mt-3">
                                  <label htmlFor="lastName" className="mb-1">
                                    Last name
                                  </label>
                                  <Field
                                    name="lastName"
                                    id="lastName"
                                    type="text"
                                    placeholder="Last name"
                                    className="form-control"
                                  ></Field>

                                  {errors.lastName && touched.lastName ? (
                                    <div className="text-danger ml-2">
                                      {errors.lastName}
                                    </div>
                                  ) : null}
                                </div>

                                <div className="form-label-group mt-3">
                                  <label htmlFor="phone" className="mb-1">
                                    Phone number{" "}
                                    <span className="text-muted small">
                                      (optional)
                                    </span>
                                  </label>
                                  <Field
                                    name="phone"
                                    id="phone"
                                    type="tel"
                                    placeholder="Phone number"
                                    className="form-control"
                                  ></Field>

                                  {errors.phone ? (
                                    <div className="text-danger ml-2">
                                      {errors.phone}
                                    </div>
                                  ) : null}
                                </div>
                                <div className="form-label-group  mt-3">
                                  <label htmlFor="email" className="mb-1">
                                    Email address
                                  </label>
                                  <Field
                                    name="email"
                                    id="email"
                                    type="email"
                                    placeholder="Email"
                                    className="form-control"
                                  ></Field>

                                  {errors.email && touched.email ? (
                                    <div className="text-danger ml-2">
                                      {errors.email}
                                    </div>
                                  ) : null}
                                </div>

                                <div className="form-label-group  mt-3">
                                  <label htmlFor="pass" className="mb-1">
                                    Password
                                  </label>
                                  <div className="d-flex align-items-center">
                                    <Field
                                      name="password"
                                      id="password"
                                      type={showPass ? "text" : "password"}
                                      placeholder="Password"
                                      className="form-control flex-grow-1"
                                    ></Field>

                                    <div
                                      className="p-2"
                                      onClick={() => {
                                        setShowPass(!showPass);
                                      }}
                                    >
                                      <FontAwesomeIcon
                                        icon={showPass ? faEye : faEyeSlash}
                                        className={
                                          darkTheme ? "text-light" : "text-dark"
                                        }
                                      />
                                    </div>
                                  </div>
                                  {errors.pass && touched.pass ? (
                                    <div className="text-danger ml-2">
                                      {errors.pass}
                                    </div>
                                  ) : null}
                                </div>

                                <div className="mt-2">
                                  <input
                                    type="checkbox"
                                    id="t_n_c"
                                    name="t_n_c"
                                    value="Boat"
                                    required={true}
                                    className="mr-1"
                                  />
                                  <label for="t_n_c">
                                    I agree to igesia's{" "}
                                    <a
                                      target="_blank"
                                      href={`https://${PROD_HOSTED_BASE_URL}/terms`}
                                    >
                                      Terms & Conditions
                                    </a>{" "}
                                    and{" "}
                                    <a
                                      target="_blank"
                                      href={`https://${PROD_HOSTED_BASE_URL}/privacy`}
                                    >
                                      Privacy Policy
                                    </a>
                                  </label>
                                </div>
                              </div>

                              <div className="mt-3">
                                <div className="d-flex">
                                  <button
                                    type="submit"
                                    className="btn btn-primary flex-grow-1"
                                    disabled={signing}
                                  >
                                    {signing && (
                                      <Spinner animation="border" size="sm" />
                                    )}{" "}
                                    Register
                                  </button>
                                </div>
                              </div>
                              <div className="d-flex justify-content-between">
                                <div className="mt-3 d-flex">
                                  <p className="text-center small mt-2 mb-0 font-weight-bold">
                                    Already have an account?{" "}
                                    <a
                                      className="text-primary"
                                      onClick={() => handleRouteChange("login")}
                                      style={{ cursor: "pointer" }}
                                    >
                                      Log in here
                                    </a>
                                  </p>
                                </div>
                                <div className="mt-3 d-flex ">
                                  <p className="text-center small mt-2 mb-0 font-weight-bold">
                                    <a
                                      className="text-primary"
                                      onClick={() =>
                                        handleRouteChange("forgot-password")
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      Forgot Password?
                                    </a>
                                  </p>
                                </div>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </div>
                    ) : (
                      <div>
                        <Formik
                          validationSchema={LoginVaildationSchema}
                          initialValues={{
                            email: email_address ?? "",
                            password: "",
                          }}
                          onSubmit={(values, { resetForm }) => {
                            handleNewLogin(
                              resetForm,
                              values.email,
                              values.password
                            );
                          }}
                        >
                          {({ errors, touched, isValidating, values }) => (
                            <Form>
                              <div className="">
                                <div className="">
                                  <div className="form-label-group  mt-3">
                                    <label htmlFor="email" className="mb-1">
                                      Email address
                                    </label>
                                    <Field
                                      name="email"
                                      id="email"
                                      type="email"
                                      placeholder="Email"
                                      className="form-control"
                                    ></Field>
                                    {errors.email && touched.email ? (
                                      <div className="text-danger ml-2">
                                        {errors.email}
                                      </div>
                                    ) : null}
                                  </div>

                                  <div className="form-label-group  mt-3">
                                    <label htmlFor="pass" className="mb-1">
                                      Password
                                    </label>
                                    <div className="d-flex align-items-center">
                                      <Field
                                        name="password"
                                        id="password"
                                        type={showPass ? "text" : "password"}
                                        placeholder="Password"
                                        className="form-control"
                                      ></Field>
                                      <div
                                        className="p-2"
                                        onClick={() => setShowPass(!showPass)}
                                      >
                                        <FontAwesomeIcon
                                          icon={showPass ? faEye : faEyeSlash}
                                          className={
                                            darkTheme
                                              ? "text-light"
                                              : "text-dark"
                                          }
                                        />
                                      </div>
                                    </div>
                                    {errors.password && touched.password ? (
                                      <div className="text-danger ml-2">
                                        {errors.password}
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              </div>

                              <div className="mt-3">
                                <div className="d-flex">
                                  <button
                                    type="submit"
                                    className="btn btn-primary flex-grow-1"
                                    disabled={loggingSpinner}
                                  >
                                    {loggingSpinner && (
                                      <Spinner animation="border" size="sm" />
                                    )}{" "}
                                    Login
                                  </button>
                                </div>
                              </div>
                              <div className="d-flex justify-content-between">
                                <div className="mt-3 d-flex">
                                  <p className="text-center small mt-2 mb-0 font-weight-bold ">
                                    Don't have an account?{" "}
                                    <a
                                      className="text-primary"
                                      onClick={() =>
                                        handleRouteChange("register")
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      Register here
                                    </a>
                                  </p>
                                </div>
                                <div className="mt-3 d-flex ">
                                  <p className="text-center small mt-2 mb-0 font-weight-bold">
                                    <a
                                      className="text-primary"
                                      onClick={() =>
                                        handleRouteChange("forgot-password")
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      Forgot Password?
                                    </a>
                                  </p>
                                </div>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </div>
                    )}
                  </div>
                </Card.Body>
              )}
            </Card>
          </div>
        </div>
      </div>
      {/* Event cover ends */}
    </div>
  );
}

export default connect(
  (state) => ({
    currentLanguage: state.currentLanguage,
    darkTheme: state.darkTheme,
    currentEvent: state.currentEvent,
  }),
  { changeLanguage, setCurrentEvent }
)(EventAuthentication);
